export const POLICY_MODES = {
    search: 'search',
    violation: 'violation',
    required: 'required',
} as const;
